const DAY_MS = 86400000;

export function localDayDiff(date, from = new Date()) {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
    if (!(from instanceof Date) || Number.isNaN(from.getTime())) return null;
    const a = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    const b = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
    return Math.round((a - b) / DAY_MS);
}

export function formatRelativeDayLabel(input, localeOptions, from = new Date()) {
    const date = input instanceof Date ? input : new Date(input);
    if (Number.isNaN(date.getTime())) return '';
    const diff = localDayDiff(date, from);
    if (diff === 0) return 'Today';
    if (diff === 1) return 'Tomorrow';
    return date.toLocaleDateString(undefined, localeOptions || {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
    });
}
